// extracted by mini-css-extract-plugin
export default {"videoCore":"index_videoCore_XXsEH"};